module.exports = __webpack_public_path__ + "img/Rutas_de_envio.9965d607.png";